<template>
  <div class="shareButton" @click="share"></div>
  <Transition name="snackBar">
    <div class="snackBar" v-if="snackBar">
      <div class="snackBarContent">
        <div class="message">
          クリップボードにコピーしました
        </div>
        <div class="action" @click="closeSnackBar">
          閉じる
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
  import { ref } from 'vue'
  // refs
  const snackBar = ref(false)
  const snackBarTimer = ref(null)
  // methods
  const share = ()=>{
    const title = document.querySelector('title').text;
    if (navigator.share) {
      navigator.share({
        title: title,
        url: location.href,
      });
    } else {
      clearTimeout(snackBarTimer.value)
      showSnackBar();
      snackBarTimer.value = setTimeout(closeSnackBar, 2000);

      const url = location.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url);
      } else {
        // Clipboard APIに対応していない場合
        const textArea = document.createElement('textarea');
        textArea.value = url;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy'); // 非推奨
        document.body.removeChild(textArea);
      }
    }
  }
  const showSnackBar = () => {
    snackBar.value = true;
  }
  const closeSnackBar = () => {
    snackBar.value = false;
  }
</script>
